---
title: "Как повернуть PDF онлайн - без загрузки на сервер"
description: "Поверните страницы PDF на 90°, 180° или 270° прямо в браузере. Без регистрации, без водяных знаков, файл не покидает ваш компьютер."
locale: "ru"
date: "2026-05-12"
tags: ["pdf", "поворот", "локально"]
relatedTools: ["povernut"]
translations:
  en: "how-to-rotate-pdf-online"
faq:
  - q: "Можно ли повернуть только одну страницу, или нужно крутить весь файл?"
    a: "Можно. В форме переключите «Какие страницы» на «Выбранные» и укажите номера через запятую: `3` для одной страницы, `1,5-7` - для нескольких. Остальные останутся в исходной ориентации."
  - q: "Сохранится ли качество PDF после поворота?"
    a: "Полностью. Поворот меняет только метаданные - одно поле в структуре PDF, - а сам контент (текст, картинки, шрифты) не пересохраняется. Размер файла после поворота тоже почти не меняется."
  - q: "Работает ли это на телефоне?"
    a: "На современных мобильных браузерах (iOS Safari 14+, Chrome Android последних версий) - да. Для очень больших PDF (>50 МБ) на старых телефонах может не хватить памяти; тогда проще открыть с ноутбука."
  - q: "Что делать с PDF, защищённым паролем?"
    a: "pdf-lib не открывает зашифрованные PDF без пароля. Сначала снимите защиту (Acrobat умеет, утилита qpdf тоже), затем поворачивайте здесь."
  - q: "Можно ли отменить поворот?"
    a: "Поворот аддитивный, поэтому достаточно повернуть в обратную сторону: после поворота на 90° сделайте второй поворот на 270° - 90 + 270 = 360, страницы вернутся в исходное положение. Если нужно полностью откатиться, сохраните оригинальный файл перед обработкой - он всё это время лежит у вас на диске."
---

import { PovernutForm } from '@/pages/povernut/PovernutForm'

Скан договора пришёл вверх ногами - все 47 страниц. Пересканировать
долго, лицензии на Acrobat нет, ставить ради одного поворота офисный
комбайн не хочется. Поворот PDF - это даже не пересборка документа, а
правка одного поля в метаданных. Делается мгновенно и без сервера.

Ниже встроен ровно такой инструмент. Перетащите PDF, выберите угол.
Если нужны не все страницы - укажите номера через запятую (`1,3,5-7`
означает страницы 1, 3, 5, 6 и 7). Поворот по часовой, прибавляется к
текущему углу. Файл никуда не уходит.

<div className="my-8 rounded-xl border bg-card p-5 shadow-sm">
  <PovernutForm />
</div>

## Почему это работает без сервера

В PDF у каждой страницы есть свойство `/Rotate` со значением 0, 90, 180
или 270. Просмотрщик при открытии просто крутит содержимое на этот угол.
Чтобы повернуть страницу, можно поменять одно число - и всё.

Чем это делается? Библиотекой [pdf-lib](https://github.com/Hopding/pdf-lib)
- JS на 440 KB, грузится один раз и работает в браузере. Можете открыть
DevTools → Network, загрузить файл выше и убедиться, что наружу не уходит
ничего, кроме JS и CSS самого сайта.

## Когда это не сработает

Метод меняет ориентацию страницы, но не её содержимое. Если внутри
страницы вложена одна большая картинка-скан с боковым текстом, поворот
страницы крутанёт картинку вместе со всем окружением - подписи, штампы,
нумерация. Тогда нужен редактор, который умеет разбирать страницу на
объекты и поворачивать растровую вставку отдельно. В браузере я такого
ещё не встречал; обычно это либо Acrobat, либо что-то на десктопе.

## Без загрузки на сервер - это важнее, чем кажется

Smallpdf, iLovePDF, PDF24 - все они грузят файл к себе на сервер,
обрабатывают, отдают результат и обещают удалить через час. Проверить
обещание никак нельзя; в Network tab видно только, что файл уехал.
Здесь видно, что не уехал. Privacy policy всегда красивая, сетевая
вкладка - честнее.

Для сканов с паспортом, договоров и любых документов под NDA это
принципиально. Для меню кафе, которое надо повернуть перед печатью -
конечно, паранойя; но платить за паранойю в данном случае ничем не
приходится.

После поворота часто хочется ещё и уменьшить файл - например, чтобы
влезть в 5 МБ для Госуслуг. Для этого есть [сжать PDF](/szhat): он тоже
работает прямо в браузере.
